export class Forms {
    /**
     * Takes a serialized array from JQuery and returns a proper object
     * @param serializedArray
     */
    public static convertSerializedArrayToObject(serializedArray: JQuerySerializeArrayElement[]) {
        const jsonObj: any = {};
        jQuery.map(serializedArray, function (n: HTMLInputElement) {
            jsonObj[n.name] = n.value;
        });

        return jsonObj;
    }
}
